var render, staticRenderFns
import script from "./DataStorage.vue?vue&type=script&lang=js&"
export * from "./DataStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5563df6c",
  null
  
)

export default component.exports